// @core/api/endpoints/chat/update_conversation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ConversationResponse,
  UpdateConversationRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Update conversation
 * Updates conversation settings such as name, description, avatar, and notification preferences. Requires admin privileges on the conversation.
 */
export async function UpdateConversation(
  conversation_id: string,
  data: UpdateConversationRequest,
  options?: RequestOptions
): Promise<ConversationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.put<ConversationResponse>(requestPath, data, requestOptions);
}
